// Centralized error handling utilities
export const handleError = (error: any, context: string = '', setError: ((msg: string) => void) | null = null): string => {
  const errorMessage = error?.message || 'An unexpected error occurred';
  const fullMessage = context ? `${context}: ${errorMessage}` : errorMessage;

  // Log error for debugging (only in development)
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${context}] Error:`, error);
  }

  // Set error state if setError function is provided
  if (setError && typeof setError === 'function') {
    setError(fullMessage);
  }

  return fullMessage;
};

export const handleFirestoreError = (error: any, context: string = '', setError: ((msg: string) => void) | null = null): string => {
  let userMessage = 'An error occurred while accessing data';

  if (error?.code) {
    switch (error.code) {
      case 'permission-denied':
        userMessage = 'You do not have permission to access this data';
        break;
      case 'not-found':
        userMessage = 'The requested data was not found';
        break;
      case 'unavailable':
        userMessage = 'Service is temporarily unavailable';
        break;
      case 'unauthenticated':
        userMessage = 'Please log in to access this data';
        break;
      default:
        userMessage = 'An error occurred while accessing data';
    }
  }

  const fullMessage = context ? `${context}: ${userMessage}` : userMessage;

  // Log error for debugging (only in development)
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${context}] Firestore Error:`, error);
  }

  // Set error state if setError function is provided
  if (setError && typeof setError === 'function') {
    setError(fullMessage);
  }

  return fullMessage;
};

export const handleAuthError = (error: any, context: string = '', setError: ((msg: string) => void) | null = null): string => {
  let userMessage = 'Authentication failed';

  if (error?.code) {
    switch (error.code) {
      case 'auth/user-not-found':
        userMessage = 'No account found with this email address';
        break;
      case 'auth/wrong-password':
        userMessage = 'Incorrect password';
        break;
      case 'auth/email-already-in-use':
        userMessage = 'An account with this email already exists';
        break;
      case 'auth/weak-password':
        userMessage = 'Password is too weak';
        break;
      case 'auth/invalid-email':
        userMessage = 'Invalid email address';
        break;
      case 'auth/too-many-requests':
        userMessage = 'Too many failed attempts. Please try again later';
        break;
      default:
        userMessage = 'Authentication failed';
    }
  }

  const fullMessage = context ? `${context}: ${userMessage}` : userMessage;

  // Log error for debugging (only in development)
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${context}] Auth Error:`, error);
  }

  // Set error state if setError function is provided
  if (setError && typeof setError === 'function') {
    setError(fullMessage);
  }

  return fullMessage;
}; 